// Ren logikk for håndtering av feil fra @capgo/background-geolocation-callbacken.
// Holdt utenfor useGpsTracking-hooken så beslutningen kan enhetstestes uten
// å måtte rendre hele hooken med LocationGate-context.

export type GpsErrorKind =
  | 'ignore-already-started' // Sporing kjører allerede native – ønsket slutt-tilstand
  | 'permission'             // Bruker har avslått posisjonstilgang
  | 'generic';               // Alt annet

export interface GpsErrorAction {
  kind: GpsErrorKind;
  /** Skal feilen rapporteres til error_reports? */
  report: boolean;
}

/**
 * Klassifiserer en feilkode fra BackgroundGeolocation-callbacken.
 *
 * ALREADY_STARTED oppstår når native locationManager fortsatt lever fra en
 * tidligere JS-sesjon (OTA kald-start, WKWebView-reload, iOS bakgrunns-relansering)
 * mens JS-tilstanden er nullstilt. Det er ikke en reell feil – sporing kjører
 * allerede – så den skal verken vises til bruker eller spamme error_reports.
 *
 * NOT_AUTHORIZED/PERMISSION_DENIED er en forventet tillatelsestilstand: brukeren
 * har ikke gitt «Tillat hele tiden». Vi viser veiledning + openSettings() i UI-et,
 * men rapporterer IKKE til error_reports – ellers spammer hver turlogg-start uten
 * bakgrunnstillatelse admin-feeden og drukner ekte krasj.
 */
export function classifyBackgroundGeoError(code: string | undefined | null): GpsErrorAction {
  const c = code || 'UNKNOWN';
  if (c === 'ALREADY_STARTED') {
    return { kind: 'ignore-already-started', report: false };
  }
  if (c === 'NOT_AUTHORIZED' || c === 'PERMISSION_DENIED') {
    return { kind: 'permission', report: false };
  }
  return { kind: 'generic', report: true };
}
